'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { HoverCard } from '../../components/hover-card';
import { Tooltip } from '../../components/tooltip';

const HOVER_CARD_MAX_HEIGHT = '220px';

type SegmentedCountBarItemOverlayProps = {
  tooltip?: string;
  tooltipContent?: ReactNode;
  hoverCardContent?: ReactNode;
  children: ReactNode;
};

export function SegmentedCountBarItemOverlay({
  tooltip,
  tooltipContent,
  hoverCardContent,
  children,
}: SegmentedCountBarItemOverlayProps) {
  if (hoverCardContent) {
    return (
      <HoverCard.Root
        positioning={{ strategy: 'fixed', placement: 'bottom', gutter: 8 }}
        openDelay={200}
        closeDelay={200}
      >
        <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
        <HoverCard.Positioner>
          <HoverCard.Content
            borderRadius="lg"
            boxShadow="md"
            bg="bg.default"
            p={3}
            zIndex="popover"
            maxW="320px"
          >
            <Box maxH={HOVER_CARD_MAX_HEIGHT} overflowY="auto">
              {hoverCardContent}
            </Box>
            <HoverCard.Arrow>
              <HoverCard.ArrowTip />
            </HoverCard.Arrow>
          </HoverCard.Content>
        </HoverCard.Positioner>
      </HoverCard.Root>
    );
  }

  return (
    <Tooltip
      title={tooltip}
      customContent={tooltipContent}
      interactive={Boolean(tooltipContent)}
      maxW={tooltipContent ? '320px' : undefined}
      allowOverflow={Boolean(tooltipContent)}
      disabled={!tooltip && !tooltipContent}
    >
      {children}
    </Tooltip>
  );
}
